<template>
	<div class="content">
		<LayoutBanner />

		<div v-loading="loading" class="notice_info min_cw">
			<div class="top">
				<p class="date">{{ infoData.noticeTitle }}</p>
				<h2 class="title">{{ infoData.createTime }}</h2>
			</div>

			<div class="con ql-editor" v-html="infoData.noticeContent"></div>
		</div>
	</div>
</template>

<script>
import LayoutBanner from "@/components/Layout/banner";
import {getNoticeInfoApi} from "@/api";

export default {
	name: "index",
	components: {
		LayoutBanner,
	},
	data() {
		return {
			loading: false,
			infoData: {},
		}
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			this.reset();
			this.loading = true;

			const res = await getNoticeInfoApi(this.$route.params.id);
			this.infoData = res.data;

			this.loading = false;
		},

		reset() {
			this.infoData = {};
		},
	}
}
</script>

<style lang="less" scoped>
.notice_info {
	padding: 60px 40px;

	.top {
		margin-bottom: 50px;

		.date {
			font-size: 22px;
			color: @gray;
			margin-bottom: 10px;
		}

		.title {
			font-size: 22px;
			color: @blackLine;
			line-height: 1.6;
		}
	}
}
</style>
